<template>
<div id="app">
  <!-- <img id="logo" src="./assets/hato-logo-vertical.png"> -->
  <!-- <img id="logo" src="~/assets/hato-logo-vertical.png"> -->
  <nav-main></nav-main>

  <div class="router-view">
    <router-view></router-view>
  </div>
  <hato-press-footer></hato-press-footer>
  <newsletter></newsletter>
</div>
</template>

<script>
import HatoPressFooter from '@/components/HatoPressFooter'
import Newsletter from '@/components/Newsletter'
import NavMain from '@/components/NavMain'
export default {
  name: 'app',
  components: {
    HatoPressFooter,
    Newsletter,
    NavMain
  }
}
</script>

<style>
@import './assets/styles/font.css';

/*@import './assets/fonts/font.sass';*/

@import './assets/styles/common.css';

/*<link type="text/css" rel="stylesheet" href="//fast.fonts.net/cssapi/ac118186-0a6e-4739-8117-8cf672d56234.css"/>*/

/*@import '//fast.fonts.net/cssapi/ac118186-0a6e-4739-8117-8cf672d56234.css';*/

/*@import 'https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,400i,600,600i,700,700i';*/

/*@import 'https://fonts.googleapis.com/css?family=Karla:400,400i,700,700i';*/

body, html {
  font-size: 18px;
  line-height: 26px;
}

#app {
  font-family: "hatoregular", 'Avenir', "Helvetica", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /*font-family: Helvetica, Arial, sans-serif;*/
  /*font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;*/
  /*font-family: 'Corporate S W01', Helvetica, Arial, sans-serif;*/
  /*font-family: 'Karla', Helvetica, Arial, sans-serif;*/
  font-size: 16px;
  line-height: 24px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #000;
  font-weight: 400;
  /*font-family: "Helvetica", Arial, sans-serif;*/
  letter-spacing: -0.05em;
  letter-spacing: 0;
  /*margin-top: 60px;*/
}

.router-view {
  /*padding-top: 60px;
  padding-top: 3rem;*/
}

img {
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 2em auto 2em;
  display: block;
}

img {
  /*-webkit-filter: contrast(1) saturate(0) invert(1);*/
}

img.fit {
  max-width: calc(100% - 120px);
  margin-top: 5rem;
  margin-bottom: 5rem;
}

iframe {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
  margin: 1em 0;
}

.iframe-wrapper {
  position: relative;
  height: 0;
  width: 100%;
}
.iframe-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  margin: 0;
}

h1 {
  font-size: 36px;
  line-height: 1.4;
  font-weight: 500;
  margin: 1em auto;
  text-align: center;
}

h2 {
  font-size: 28px;
  line-height: 1.6;
  margin: 1em auto;
  font-weight: 400;
}

h3 {
  margin: 0 0 .5em 0;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
}

h4 {
  margin-bottom: 1em;
  font-weight: 400;
  font-size: 22px;
  font-weight: 400;
  line-height: 34px;
}

p {
  margin: 0 auto 1.5em;
  font-size: 16px;
  line-height: 24px;
}

.pos__content__center {
  margin-left: auto;
  margin-right: auto;
}
.size__content__wide {
  max-width: 1200px;
}
.size__content__basic,
.size__content__default {
  max-width: 1000px;
}
.size__content__narrow {
  max-width: 800px;
}


@media screen and (max-width: 1024px) {
  body, html {
    font-size: 16px;
    line-height: 26px;
  }
}

@media screen and (max-width: 768px) {
  body, html {
    font-size: 16px;
    line-height: 26px;
  }
  h2 {
    font-size: 2rem;
  }
  p, h3, h4, h5 {
    font-size: 16px;
    line-height: 26px;
  }
}
@media screen and (max-width: 640px) {
  body, html {
    font-size: 14px;
    line-height: 21px;
  }
  h2 {
    font-size: 1.5rem;
  }
  p, h3, h4, h5 {
    font-size: 14px;
    line-height: 21px;
  }
}
/*h1,h2,h3,h4 {
  padding-left: 20px;
  padding-right: 20px;
}*/
</style>



// WEBPACK FOOTER //
// App.vue?6c650c32